/// <reference path="../../../../components/common/payroll.service.ts" />
/// <reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/modal/modal.interface.ts"/>
///<reference path="../../../../components/common/identity.service.ts"/>
///<reference path="../../../../components/busy/busy.service.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>

module Meevo.Plugins.Reports {

    import BusyService = Meevo.Components.Busy.BusyService;
    import IReportControl = Meevo.Model.IReportControl;
    import ISelectItem = Meevo.Model.ISelectItem;
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import ICollectionBase = Meevo.Components.Controls.SmartMover.ICollectionBase;

    interface IReportScope extends ng.IScope {
    }

    interface IModalScope extends ng.IScope {
        close: () => void;
        data: any[];
    }

    interface IDp005MainModel {
        OnlyProductsCreatedOrUpdatedByCurrentUser: boolean;
        OnlyProductsCreatedOrUpdatedToday: boolean;
        CurrentUserId: string;
        IncludeRetail: boolean;
        IncludeShopSupply: boolean;
        ManufacturerList_TBL: string[];
        ProductCatList_TBL: string[];
        ProductList_TBL: string[];
        LabelsStartPosition: number;
        IncludeBarcode: boolean;
        IncludeSkucode: boolean;
        IncludePrice: boolean;
        BasedOnOnhand: boolean;
        SpecificNumber: boolean;
        NumberOfLabels: number;
        ProductListWithLabelCounts_TBL: IProductWithLabelCount[];
        SortReportByDP005:number;
        LabelType: DP005LabelTypeEnum;
    }

    interface IProductVariant {
        displayName: string;
        homeLocationId: number;
        id: string;
        objectState: string;
        sku: string;
        variantDisplayName: string;
        numberOfLabels: number;
    }

    interface IProductWithLabelCount {
        numberOfLabels: number;
        productDisplayName: string;
        product_TId: string;
        sku: string;
        variantDisplayName: string;
        variant_TId: string;
    }

    interface IMoverProductWithLabelCount extends IProductWithLabelCount {
        displayName: string;
    }

    enum BasedOnTypeEnum {
        hand = 1,
        numberOfLabels
    }

    enum SortBy {
        manufacturer = 1,
        productCategories
    }


    class MeevoReportDp005Component implements angular.IComponentController {

        static $inject = [
            '$scope',
            '$mdDialog',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.IdentityService',
        ];

        public numberOfLabels: number[];
        public sheetBlocks: number[][];

        public mainModel: IDp005MainModel;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IReportControl;

        public sortByModel: SortBy;
        public sortBy: ISelectItem<SortBy>[];

        public fetching: boolean;

        public productCriteria: any = {};
        public customData: any;
        public customNumberOfLabels: boolean;
        public showProductMover = false;

        private _startLabelOfTheBeginning: boolean = false;

        private _basedOnModel: BasedOnTypeEnum = BasedOnTypeEnum.hand;
        private productListWithOnHandValues: { variant_TId: string; numberOfLabels: number; }[];
        private manufacturersIDs: number[];
        private prodCatsIDs: number[];

        get valid() {
            const res = this.mainModel.ProductListWithLabelCounts_TBL;

            return res instanceof Array && res.length > 0;
        }

        get retailOrShopSupplySelected(): boolean {
            return this.mainModel.IncludeRetail || this.mainModel.IncludeShopSupply;
        }

        set basedOnModel(value: BasedOnTypeEnum) {
            if (value === BasedOnTypeEnum.hand) {
                this.mainModel.BasedOnOnhand = true;
                this.mainModel.SpecificNumber = false;
            } else {
                this.mainModel.BasedOnOnhand = false;
                this.mainModel.SpecificNumber = true;
            }

            this._basedOnModel = value;
            this.changeNumberOfLabels();
        }

        get basedOnModel() {
            return this._basedOnModel;
        }

        set startLabelOfTheBeginning(value: boolean) {
            this._startLabelOfTheBeginning = value;
            if (value) {
                this.mainModel.LabelsStartPosition = 1;
            }
        }

        get startLabelOfTheBeginning() {
            return this._startLabelOfTheBeginning;
        }

        get showPreviewButton(): boolean {
            return [this.mainModel.BasedOnOnhand, this.mainModel.SpecificNumber].filter(row => row).length > 0;
        }

        get isFromPO(): boolean {
            return !!this.customData;
        }

        get hasCustomNumberOfLabels(): boolean {
            return this.customNumberOfLabels;
        }

        get POisShopSupply(): boolean {
            return this.customData && (this.customData.productInventoryType === ProductInventoryTypeEnum.ShopSupply);
        }

        get sortByEnum() {
            return SortBy;
        }

        constructor(protected $scope: IReportScope,
                    protected $mdDialog: ng.material.IDialogService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected busyService: BusyService,
                    private identityService: Meevo.Components.Common.IdentityService) {
            this.fetching = false;
            this.productListWithOnHandValues = [];
            this.numberOfLabels = _.range(1, 81, 1);

            const numOfRows = this.mainModel.LabelType === DP005LabelTypeEnum.avery4736 ? 12 : 20;
            this.sheetBlocks = _.range(numOfRows).map((num, index) => _.range(index * 4 + 1, index * 4 + 5, 1));
            this.sheetBlocks[0][0] = 1;
            this.mainModel.BasedOnOnhand = true;
            this.mainModel.SpecificNumber = false;

            this.sortBy = [
                { label: 'LABEL_MANUFACTURER', value: SortBy.manufacturer },
                { label: 'LABEL_INPUT_PRODUCT_CATEGORY', value: SortBy.productCategories }
            ];
            this.manufacturersIDs = [];
            this.prodCatsIDs = [];
            this.sortByModel = SortBy.manufacturer;

            this.onCollectionFetched = this.onCollectionFetched.bind(this);
        }

        $onInit() {
            this.selectSheetPosition(1);
            this.mainModel.CurrentUserId = this.identityService.loggedInUserId().toString();
            this.mainModel.ProductCatList_TBL = [];
            this.mainModel.ManufacturerList_TBL = [];
            this.mainModel.SortReportByDP005 = this.sortByModel;
            if (this.isFromPO) {
                setTimeout(() => {
                    this.$scope.$apply(() => {
                        this.buildCriteria();
                    });
                });
            }
        }

        selectSheetPosition(position: number) {
            this.mainModel.LabelsStartPosition = position;
            this.startLabelOfTheBeginning = false;
        }

        sortByChanged() {
            this.showProductMover = false;
            (this.mainModel.ProductListWithLabelCounts_TBL || []).length = 0;
            this.mainModel.SortReportByDP005 = this.sortByModel;
        }

        buildCriteria() {
            this.showProductMover = true;

            this.productCriteria = {
                IncludeRetail: this.mainModel.IncludeRetail,
                IncludeShopSupply: this.mainModel.IncludeShopSupply,
                OnlyProductsCreatedOrUpdatedToday: this.mainModel.OnlyProductsCreatedOrUpdatedToday,
                OnlyProductsCreatedOrUpdatedByCurrentUser: this.mainModel.OnlyProductsCreatedOrUpdatedByCurrentUser,
                CurrentUserId: this.mainModel.CurrentUserId,
                BasedOnOnhand: this.mainModel.BasedOnOnhand,
                SpecificNumber: this.mainModel.SpecificNumber,
                NumberOfLabels: this.mainModel.NumberOfLabels,
                ManufacturerList_TBL: this.sortByModel === SortBy.manufacturer ? angular.copy(this.manufacturersIDs) : [],
                ProductCat_TBL: this.sortByModel === SortBy.productCategories ? angular.copy(this.prodCatsIDs) : [],
                ProductCatList_TBL: this.sortByModel === SortBy.productCategories ? angular.copy(this.prodCatsIDs) : [],
                ProductState_TBL: [2026]
            };

            if (this.isFromPO) {
                if (this.customData.transferNumber)
                    this.productCriteria['InventoryTransferId'] = this.customData.id;
                else
                this.productCriteria['PurchaseOrderHeaderId'] = this.customData.id;
            }
        }

        changeNumberOfLabels() {
            this.mainModel.ProductListWithLabelCounts_TBL.forEach((item) => {
                item['numberOfLabels'] = this.getOnHandValueByVariantId(item.variant_TId);
            });
        }

        openPreview() {
            let modalScope: IModalScope = <IModalScope>this.$scope.$new(true);

            modalScope.close = () => {
                this.mainModel.ProductListWithLabelCounts_TBL = modalScope.data;
                this.$mdDialog.cancel();
            };

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/reports/components/dp005/meevo-report-dp005-modal.html',
                scope: modalScope
            };

            modalScope.data = this.mainModel.ProductListWithLabelCounts_TBL;
            this.modalService.showCustom(options);
            this.busyService.stop();
        }

        getOnHandValueByVariantId(variantId: string): number {
            if (this._basedOnModel === BasedOnTypeEnum.numberOfLabels) {
                return this.mainModel.NumberOfLabels;
            }

            const variant = _.findWhere(this.productListWithOnHandValues, { variant_TId: variantId });

            return variant ? variant.numberOfLabels || 0 : 0;
        }

        changeShopSupply() {
            if (this.isFromPO) {
                this.buildCriteria();
            }
        }

        onCollectionFetched(collection: ICollectionBase<IReportDP005Product>) {
            this.productListWithOnHandValues = collection.responseList.map((row) => {
                return {
                    variant_TId: row.variant_TId,
                    numberOfLabels: row.numberOfLabels
                }
            });
        }
    }

    angular.module('meevo.plugins.reports')
        .component('meevoReportDp005Component', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/dp005/meevo-report-dp005.component.html',
            controller: MeevoReportDp005Component,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                options: '<',
                customData: '<',
                customNumberOfLabels: '=?'
            }
        });
}
